var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Selector',{attrs:{"return-object":"","items":_vm.locations,"label":_vm.$t('destinations'),"initialItem":_vm.initialDestination,"solo":_vm.solo,"outlined":_vm.outlined,"rounded":_vm.rounded,"dense":_vm.dense,"dark":_vm.dark,"color":_vm.color,"prependInnerIcon":_vm.prependInnerIcon,"itemText":"name"},on:{"item-selected":_vm.locationSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }